module.exports = "<button class=\"mr-10\"\n  rtebutton-flat color=\"primary\"\n  (click)=\"onViewReport.emit()\">\n  Exibir relatório\n</button>\n"